<template>
<div :class="$style.root">
  <el-card>
    <div slot="header">
      <span>缴费</span>
    </div>
    <el-form
      label-position="left"
      label-width="80px"
      style="width:480px;"
      size="small"
      :model="form"
      :rules="formRules"
      :hide-required-asterisk="true"
      ref="form">

      <el-form-item label="测点编码" prop="stationcode">
        <el-input v-model="form.stationcode" :readonly="true"></el-input>
      </el-form-item>
      <el-form-item label="测点名称" prop="stationname">
        <el-input v-model="form.stationname" :readonly="true"></el-input>
      </el-form-item>

      <el-form-item label="开始时间" prop="stime">
        <el-date-picker
          v-model="form.stime"
          type="date"
          value-format="yyyy-MM-dd"
          :readonly="true"
          style="width: 100%;"
          placeholder="选择开始时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="结束时间" prop="etime">
        <el-date-picker
          v-model="form.etime"
          type="date"
          value-format="yyyy-MM-dd"
          :readonly="true"
          style="width: 100%;"
          placeholder="选择结束时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="总用水量" prop="quantity">
        <el-input v-model="form.quantity" :readonly="true"></el-input>
      </el-form-item>

      <el-form-item label="总费用" prop="total_price">
        <el-input v-model="form.total_price" :readonly="true"></el-input>
      </el-form-item>

      <el-form-item label="缴费人" prop="payman">
        <el-input v-model="form.payman" ></el-input>
      </el-form-item>

      <el-form-item label="缴费单位" prop="payunit">
        <el-input v-model="form.payunit" ></el-input>
      </el-form-item>

      <el-form-item label="收款人" prop="accessman">
        <el-input v-model="form.accessman" ></el-input>
      </el-form-item>

      <el-form-item label="收款单位" prop="accessunit">
        <el-input v-model="form.accessunit" ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button icon="el-icon-circle-check-outline" type="primary" @click="submit('form')" :disabled="submitted">提交</el-button>
        <el-button icon="el-icon-arrow-left" @click="$router.back()">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</div>
</template>

<script>
import {payPriceReport} from "@/apis/api";

export default {
  data() {
    return {
      submitted: false,

      form: {
        userid: sessionStorage.getItem('userid'),
        stationname: null,
        stationcode: null,
        stime: null,
        etime: null,
        payman: null,
        payunit: null,
        accessman: null,
        accessunit: null
      },
      formRules: {
        payman: [
          { required: true, message: '请输入缴费人', trigger: 'change' }
        ],
        payunit: [
          { required: true, message: '请输入缴费单位', trigger: 'change' }
        ],
        accessman: [
          { required: true, message: '请输入收款人', trigger: 'change' }
        ],
        accessunit: [
          { required: true, message: '请输入收款单位', trigger: 'change' }
        ],
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.form = Object.assign({}, vm.form, vm.$route.query)
    })
  },
  methods: {
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          payPriceReport({
            stime: this.form.stime,
            etime: this.form.etime,
            fycd: this.form.stationcode,
            data: JSON.stringify(this.form)
          }).then(res => {
            if(res.code == 0) {
              this.$message({
                message: res.message || '操作失败',
                type: 'warning'
              })
            } else {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.submitted = true
            }
          }).catch(err => {
            this.$message({
              message: '操作失败',
              type: 'danger'
            })
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" module>
.root {
  padding: 1em;
  :global(.el-form) {
    margin: 0 auto;
  }
}
.root, .root > :global(.el-card){
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/payment/pay.vue